<template>
  <div class="radio-group clearfix">
    <div
      v-for="option in options"
      :key="option.value"
      class="radio-button-container"
    >
      <RadioButton
        v-bind="option"
        :id="`${id}-${option.value}`"
        :disabled="disabled"
        :checked="value === option.value ? 'checked' : null"
        @check="$emit('update:value', option.value)"
      />
    </div>
  </div>
</template>

<style lang="scss">
.radio-group {
  margin: rem(0 0 22px);

  .radio-button-container {
    margin-right: rem(20px);
    float: left;
  }
}
</style>

<script>
import RadioButton from "./RadioButton";

export default {
  components: {
    RadioButton,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: [Boolean, String, Number],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
